'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Flame } from 'lucide-react';
const HERO_IMAGE_SRC = '/static/home/sizzle-nz-hero.png';
const AUDIENCES = ['Brands', 'Retailers', 'Buyers', 'Distributors', 'Importers', 'Brokers', 'Consultants', 'Agencies', 'Suppliers'];
export function HeroSectionSizzleNZ() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-x-0 top-0 h-1 bg-primary-500" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-white"><Flame className="h-4 w-4" aria-hidden="true" /></span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative z-10 flex flex-col lg:col-span-6 xl:col-span-6 xl:justify-center xl:gap-10"><div><Link href="/early-preview" className="mb-4 inline-flex items-center gap-2 text-sm font-semibold text-gray-700 transition-colors hover:text-primary-600 sm:mb-7">{t1}<span>Early Preview - <span className="text-primary-600 underline">Learn more</span></span></Link><h1 className="max-w-3xl text-4xl font-black leading-[1.02] tracking-normal text-gray-950 sm:text-5xl lg:text-5xl xl:text-5xl">{"New Zealand's Food, Beverage and Consumer Goods Demand & Growth Platform"}</h1></div><p className="mt-2 max-w-xl font-bold text-3xl text-gray-600 sm:mt-4 sm:text-3xl xl:mt-0">Helping you Make Smarter Moves to Create More Demand for your products and Convert that Demand into Purchases.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="grid items-center gap-4 sm:gap-8 lg:grid-cols-12 lg:gap-6 xl:items-stretch xl:gap-10">{t2}<div className="relative h-[270px] sm:h-[470px] lg:col-span-6 lg:h-[520px] xl:col-span-6 xl:h-[560px]"><img src={HERO_IMAGE_SRC} alt="Illustrated New Zealand consumer brands building momentum through Sizzle" className="absolute inset-0 h-full w-full object-contain" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="mb-2 text-base text-gray-600 sm:mb-3 sm:text-xl">Sizzle is for:</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section className="relative isolate overflow-hidden border-b border-orange-100 bg-[#fffaf4]">{t0}<div className="relative mx-auto max-w-[1440px] px-5 py-5 sm:px-8 sm:py-6 lg:px-12 lg:py-6">{t3}<div className="mt-4 border-t border-gray-900/15 pt-4 sm:mt-8 sm:pt-5 lg:mt-6">{t4}<div className="flex flex-wrap gap-x-4 gap-y-1 sm:gap-x-5 sm:gap-y-2">{AUDIENCES.map(_temp)}</div></div></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp(audience) {
  return <span key={audience} className="text-sm font-semibold text-gray-800 sm:text-base">{audience}</span>;
}